import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import {
  Registration,
  Subscription,
  Login,
} from '@C/Registration/RouteComponents';

const RouteSetup = () => {
  return (
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route path="/register" component={Registration} />
      <Route path="/subscription" component={Subscription} />
    </Switch>
  );
};

export { RouteSetup };
